// extracted by mini-css-extract-plugin
export default {"desc":"components_desc__TOme8","applyLog":"components_applyLog__NibZn","danger":"components_danger__A45FI"};